import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'hy', name: 'Հայերեն', flag: '🇦🇲' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  ];

  return (
    <div className={styles.switcher}>
      {languages.map(({ code, name, flag }) => (
        <button
          key={code}
          className={`${styles.btn} ${i18n.language === code ? styles.active : ''}`}
          onClick={() => i18n.changeLanguage(code)}
          title={name}
        >
          <span className={styles.flag}>{flag}</span>
          <span className={styles.text}>{code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
